module.exports = __webpack_public_path__ + "img/illu-boat.868142f8.svg";